module.exports = __webpack_public_path__ + "img/writing.82fb49b0.png";